import Core from '../Core';
export default class CoreStorage {
    constructor(options, browserStorage) {
        this.options = options;
        this.browserStorage = browserStorage;
    }
    /**
     * Returns if storages are available or not
     *
     */
    isEnabled() {
        return this.browserStorage.isEnabled();
    }
    /**
     * Sets data in the local storage
     * @param key
     * @param value
     */
    setLocal(key, value) {
        this.browserStorage.setLocal(key, value);
    }
    /**
     * Gets data from the local storage
     * @param key
     * @returns
     */
    getLocal(key) {
        return this.browserStorage.getLocal(key);
    }
    /**
     * Returns service host
     *
     */
    getHost() {
        let host = this.options.getHost();
        const fastData = Core.getInstance().getFastDataService();
        if (fastData && fastData.getFastDataResponse() && fastData.getFastDataResponse().host) {
            host = fastData.getFastDataResponse().host;
        }
        return host;
    }
    /**
     *
     * @returns {*}
     */
    getSession() {
        let ret = this.browserStorage.getStorages('session');
        // Some tvs set the value as 'undefined' as string when deleting the value
        if (ret === 'undefined') {
            ret = undefined;
        }
        if (!ret) {
            let data = this.getStoredData();
            if (data) {
                try {
                    ret = JSON.parse(data).q.c;
                }
                catch (err) {
                    // nothing
                }
            }
        }
        return ret;
    }
    getStorageHost() {
        let ret = null;
        let data = this.getStoredData();
        if (data) {
            try {
                ret = JSON.parse(data).q.h;
            }
            catch (err) {
                // nothing
            }
        }
        return ret;
    }
    // AccountCode
    getLocalAccountCode() {
        return this.browserStorage.getLocal('accCode');
    }
    getSessionAccountCode() {
        return this.browserStorage.getSession('accCode');
    }
    // AppAnalyticsRegisteredProperties
    getAppAnalyticsRegisteredProperties() {
        return this.browserStorage.getLocal('appAnalyticsRegisteredProperties');
    }
    setAppAnalyticsRegisteredProperties(registeredProperties) {
        this.browserStorage.setLocal('appAnalyticsRegisteredProperties', registeredProperties);
    }
    removeAppAnalyticsRegisteredProperties() {
        this.browserStorage.removeLocal('appAnalyticsRegisteredProperties');
    }
    // AppAnalyticsStarted
    getAppAnalyticsStarted() {
        return this.browserStorage.getLocal('appAnalyticsStarted') === 'true';
    }
    setAppAnalyticsStarted(sessionStarted) {
        this.browserStorage.setLocal('appAnalyticsStarted', String(sessionStarted));
    }
    removeAppAnalyticsStarted() {
        this.browserStorage.removeStorages('appAnalyticsStarted');
    }
    // DataTime
    getDataTime() {
        return this.browserStorage.getStorages('dataTime');
    }
    setDataTime(time) {
        this.browserStorage.setStorages('dataTime', time);
    }
    // LastActive
    getLastActive() {
        return Number(this.browserStorage.getStorages('lastactive'));
    }
    setLastActive(lastActive) {
        this.browserStorage.setStorages('lastactive', lastActive);
    }
    removeLastActive() {
        this.browserStorage.removeStorages('lastactive');
    }
    // Session
    setSession(session) {
        this.browserStorage.setStorages('session', session);
    }
    removeSession() {
        this.browserStorage.removeStorages('session');
    }
    // SessionExpire
    getSessionExpire() {
        return Number(this.browserStorage.getLocal('sessionExpire')) * 1000;
    }
    // StoredData
    getStoredData() {
        return this.browserStorage.getStorages('data');
    }
    setStoredData(data) {
        this.browserStorage.setStorages('data', data);
    }
    removeStoredData() {
        this.browserStorage.removeStorages('data');
    }
}
